import React from 'react';
import { appIcon } from 'src/assets';

interface Props {
  wrapperClassName: string;
  imageClassName: string;
  imageSrc: string;
  wrapperStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  imageChildren?: React.ReactNode;
}
export const ApartmentImage: React.FC<Props> = ({
  wrapperClassName, wrapperStyle, imageClassName, imageStyle, imageSrc, imageChildren,
}) => {
  return (
    <div
      className={wrapperClassName}
      style={wrapperStyle}
    >
      <img
        alt="plan"
        className={imageClassName}
        style={imageStyle}
        src={imageSrc}
      />
      {imageChildren && (
        imageChildren
      )}
    </div>
  );
};
